export const isBot = (): boolean => {
  const botPatterns = [
    'bot',
    'spider',
    'crawler',
    'googlebot',
    'bingbot',
    'slurp',
    'duckduckbot',
    'baiduspider',
    'yandexbot',
    'sogou',
    'exabot',
    'facebookexternalhit',
    'ia_archiver',
    'semrushbot',
    'ahrefsbot'
  ].map(pattern => new RegExp(pattern, 'i'))
  return botPatterns.some(pattern => pattern.test(navigator.userAgent))
}
